import { loadRemoteModule, registerExternalGetter } from '@meego/remote-loader';

// TODO：灰度去掉之后，把引用的 key 也改掉
const externalRemoteGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {
  '@meego-progressive/metrics/stores': [
    () => loadRemoteModule('@meego-remote/metrics', './stores'),
    [],
  ],
  '@meego-progressive/metrics/pages': [
    () => loadRemoteModule('@meego-remote/metrics', './pages'),
    [],
  ],
  '@meego-progressive/metrics/pages/view': [
    () => loadRemoteModule('@meego-remote/metrics', './pages/view'),
    [],
  ],
  '@meego-progressive/metrics/pages/detail': [
    () => loadRemoteModule('@meego-remote/metrics', './pages/detail'),
    [],
  ],
  '@meego-progressive/metrics/pages/config': [
    () => loadRemoteModule('@meego-remote/metrics', './pages/config'),
    [],
  ],
  '@meego-progressive/metrics/pages/mainPageChartList': [
    () => loadRemoteModule('@meego-remote/metrics', './pages/mainPageChartList'),
    [],
  ],
  '@meego-progressive/metrics/pages/dialogAndDrawer': [
    () => loadRemoteModule('@meego-remote/metrics', './pages/dialogAndDrawer'),
    [],
  ],
  '@meego-progressive/metrics/utils': [
    () => loadRemoteModule('@meego-remote/metrics', './utils'),
    [],
  ],
  '@meego-progressive/metrics/utilsForDetail': [
    () => loadRemoteModule('@meego-remote/metrics', './utilsForDetail'),
    [],
  ],
  '@meego-progressive/metrics/chartDataAsyncManager': [
    () => loadRemoteModule('@meego-remote/metrics', './chartDataAsyncManager'),
    [],
  ],
  '@meego-progressive/metrics/components': [
    () => loadRemoteModule('@meego-remote/metrics', './components'),
    [],
  ],
  '@meego-progressive/metrics/externals': [() => import('./metricExternal')],
};

externalRemoteGetterMap['@meego-remote/metrics/common-deps'] = [() => Promise.resolve(), []];

const init = () => {
  Object.entries(externalRemoteGetterMap).forEach(([name, [getter, dependencies]]) =>
    registerExternalGetter(name, getter, dependencies),
  );
};

export { init };
